import { useHelpCenterStore } from "@/features/help-center/stores/helpCenterStore";

export const SUPPORT_EMAIL = {
  to: "support@picklebet.com",
  subject: "Help me, picklebet!",
  body: "Dear picklebet,\n\n",
};

export const supportPanic = () => {
  alert("Please email " + SUPPORT_EMAIL.to);
};

export const composeSupportEmail = () => {
  if (typeof location !== "undefined") {
    location.href = `mailto:${SUPPORT_EMAIL.to}?subject=${encodeURIComponent(
      SUPPORT_EMAIL.subject,
    )}&body=${encodeURIComponent(SUPPORT_EMAIL.body)}`;
  } else supportPanic();
};

// document the function
/**
 * Opens the help center with the given search query and labels.
 * @param options - the options to open the help center with
 * @param showAlertFallback - show old school alert box to contact support if zendesk isn't loaded
 * @param options.search - the search query
 * @param options.labels - the labels to filter by, these are set in the help center against each article
 * @param options.articleId - the article id to open. e.g. 360001041876 in https://help.picklebet.com/hc/en-us/articles/360001041876-Withdrawal-Issues
 * @example
 * open({ search: "how to bet", labels: ["betting"] })
 * @example
 * open({ search: "how to bet" })
 */
export const open = (
  options: { search?: string; labels?: Array<string>; articleId?: string } = {},
  showAlertFallback = true,
) => {
  const { openHelpCenter } = useHelpCenterStore.getState();

  if (typeof zE !== "undefined") {
    openHelpCenter(options);
  } else if (showAlertFallback) {
    supportPanic();
  }
};

export const openWithChat = () => {
  const { openHelpCenterChat } = useHelpCenterStore.getState();
  openHelpCenterChat();
};
